import { PropsWithChildren } from 'react';
import { Toaster } from 'react-hot-toast';
import {
  BrowserRouter as Router,
  matchPath,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import { Footer, Header } from './components/Molecules';
// import ClubInvitationRoute from './navigator/ClubInvitationRoute';
// import ClubMembershipTierRoute from './navigator/ClubMembershipTierRoute';
// import ClubRedeemRoute from './navigator/ClubRedeemRoute';
// import NameCardRoute from './navigator/NameCardRoute';
// import ReferralRoute from './navigator/ReferralRoute';
// import ReservedNameRoute from './navigator/ReservedNameRoute';
// import { WEAHeader } from './components/Molecules';
import { WebPageType } from './constants/webPageType';
import AccountRoute from './navigator/AccountRoute';
import AuthRoute from './navigator/AuthRoute';
import CreateMemoryGameRoute from './navigator/CreateMemoryGameRoute';
import PromotionRoute from './navigator/PromotionRoute';
import ShareRoute from './navigator/ShareRoute';
// import SmartParentsRoute from './navigator/SmartParentsRoute';
import SpaceRoute from './navigator/SpaceRoute';
import WEARoute from './navigator/WEARoute';
import WebProductRoute from './navigator/WebProductRoute';
import { PostScreen } from './screens/Posts/PostScreen';
import { Clock } from './stores/TimeStore';
import { PopupProvider, ShareDataProvider } from './context';

import './App.css';

function App() {
  return (
    <>
      <Clock />
      <AppProviders>
        <Router>
          <Layout>
            <Routes>
              <Route path="/*" element={<AuthRoute />} />
              {/* <Route path="/club-invite/*" element={<ClubInvitationRoute />} /> */}
              {/* <Route path="/referral/*" element={<ReferralRoute />} /> */}
              {/* <Route path="/referrals/*" element={<ReferralsRoute />} /> */}
              {/* <Route path="/reserved-name/*" element={<ReservedNameRoute />} /> */}
              {/* <Route path="/name-card/*" element={<NameCardRoute />} /> */}
              {/* <Route path="/club-redeem/*" element={<ClubRedeemRoute />} /> */}
              {/* <Route
                path="/club-membership-tier/*"
                element={<ClubMembershipTierRoute />}
                /> */}
              {/* These 3 routes is for IOS app */}
              <Route path="/posts/:id" element={<PostScreen />} />
              <Route path="/share/*" element={<ShareRoute />} />
              <Route path="/promotion/*" element={<PromotionRoute />} />
              {/* <Route path="/smart-parents/*" element={<SmartParentsRoute />} /> */}
              <Route
                path="/create/memory-game/*"
                element={<CreateMemoryGameRoute />}
              />
              <Route
                path="/settings/*"
                element={<AccountRoute webPageType={WebPageType.JOYAJOY} />}
              />
              <Route path="/club/*" element={<SpaceRoute />} />
              <Route path="/store/*" element={<WebProductRoute />} />
              <Route path="/wea-member/*" element={<WEARoute />} />
            </Routes>
          </Layout>
          <Toaster
            position="top-center"
            toastOptions={{
              success: { style: { background: '#e5e5e5', color: '#333333' } },
              error: { style: { background: '#ED676A', color: 'white' } },
            }}
          />
        </Router>
      </AppProviders>
    </>
  );
}

export default App;

const AppProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ShareDataProvider>
      <PopupProvider>{children}</PopupProvider>
    </ShareDataProvider>
  );
};

const Layout = ({ children }: PropsWithChildren) => {
  const location = useLocation();

  const withoutHeaderFooterRoutes = [
    // Album
    '/club/:classroomId/journey/:gameSetId/',
    // InGame
    '/club/:classroomId/journey/:gameSetId/game/:gameId',
    '/club/:classroomId/journey/:gameSetId/game/:gameId/analysis',
    '/club/:classroomId/journey/:gameSetId/game/:gameId/helper',
    // '/club/:classroomId/journey/:gameSetId/challenge/super',
    '/club/:classroomId/journey/:gameSetId/challenge/:challengeIndex',
    '/club/:classroomId/journey/:gameSetId/game/:gameId/share',
    '/club/:classroomId/journey/:gameSetId/challenge/:challengeIndex/share',
  ];

  const withoutFooterRoutes = ['/create/memory-game/*'];

  const isWEARoute = location.pathname.startsWith('/wea-member');

  const shouldRenderHeader = !withoutHeaderFooterRoutes.some((route) =>
    matchPath(route, location.pathname),
  );

  const shouldRenderFooter =
    shouldRenderHeader &&
    !withoutFooterRoutes.some((path) => matchPath(path, location.pathname));

  const hasPatentTextRoutes = [
    '/',
    '/start',
    '/login',
    '/register',
    '/register/success',
    '/forgot-password',
    'reset-password',
  ];

  const hasPatentText = hasPatentTextRoutes.some((route) =>
    matchPath(route, location.pathname),
  );

  return (
    <div className="site-container">
      {shouldRenderHeader && (
        <Header
          webPageType={isWEARoute ? WebPageType.WEA : WebPageType.JOYAJOY}
        />
      )}
      <main className="content">{children}</main>
      {shouldRenderFooter && (
        <Footer
          webPageType={isWEARoute ? WebPageType.WEA : WebPageType.JOYAJOY}
          hasPatentText={hasPatentText}
        />
      )}
    </div>
  );
};
